// Positive amount with at most two decimal places (no sign, no exponent).
const AMOUNT_REGEX = /^\d+(\.\d{1,2})?$/;

export const isValidAmount = (value: number | string | undefined | null) => {
  if (value === undefined || value === null || value === "") return false;
  const amount = Number(value);
  return (
    Number.isFinite(amount) &&
    amount > 0 &&
    AMOUNT_REGEX.test(String(value).trim())
  );
};

// Props for NumericFormatCustom: block the minus sign and limit to cents.
export const POSITIVE_AMOUNT_INPUT_PROPS = {
  allowNegative: false,
  decimalScale: 2,
};
